import { cva } from '@flipster/styled-system/css';

export const button = cva({
  base: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    px: 20,
    rounded: 4,
  },
  variants: {
    display: {
      flex: { display: 'flex', width: '100%' },
      inlineFlex: { display: 'inline-flex', width: 'auto' },
    },
    mode: {
      light: { bg: 'content.accent.info', color: 'inverse.white' },
    },
    size: {
      large: { height: [46, 50], textStyle: 'Text/L/Strong' },
      medium: { height: 40, textStyle: 'Text/S/Strong' },
    },
  },
  defaultVariants: {
    display: 'flex',
    mode: 'light',
    size: 'medium',
  },
});
